export const definedTranslation = {
  mainTitle: {
    id: 'sim-main-title',
    defaultMessage: 'Similar Items',
  },
  bottomBannerTitle: {
    id: 'sim-bottom-title',
    defaultMessage: 'Similar items that match your selection',
  },
  bottomBannerSubtitle: {
    id: 'sim-bottom-subtitle',
    defaultMessage: 'In stock and ready to ship overnight.',
  },
  sustainabilityStarLabel: {
    id: 'sim-sustainability-star-label',
    defaultMessage: "You're a sustainability star!",
  },
  sustainabilitySecondLabel: {
    id: 'sim-sustainability-second-label',
    defaultMessage: 'You saved 3 packages!',
  },
  reduceEmissionsLabel: {
    id: 'sim-reduce-emissions-label',
    defaultMessage: 'Add more items, reduce emissions',
  },
  reduceEmissionsSecondLabel: {
    id: 'sim-reduce-emissions-second-label',
    defaultMessage:
      'Multiple items in a single box reduces waste and transportation emissions',
  },
  bannerSubtitleDefaultText: {
    id: 'sim-banner-subtitle-default-text',
    defaultMessage:
      'This sample is not currently in stock, it will ship directly from the brand.',
  },
  shipping: {
    stock: {
      id: 'sim-in-stock-label',
      defaultMessage: 'Ships Overnight from Material Bank',
    },
    oos: {
      id: 'sim-oos-label',
      defaultMessage: 'Ships in 2-5+ days from brand',
    },
  },
  notAddedToCartLabel: {
    id: 'sim-item-was-not-added-label',
    defaultMessage: 'Limited Access',
  },
  addedToCartLabel: {
    id: 'sim-add-to-cart-label',
    defaultMessage: 'Added to Cart',
  },
  pleaseSelectProjectMessage: {
    id: 'sim-select-project-notification-message',
    defaultMessage: 'Please select a project',
  },
};
